import rdf from '@zazuko/env';
import fromStream from 'rdf-dataset-ext/fromStream.js';
import { meta } from '@zazuko/vocabulary-extras-builders';
import { findNodes } from 'clownface-shacl-path';
import { isGraphPointer } from 'is-graph-pointer';
import { constructQuery } from '@hydrofoil/shape-to-query';
import { fromHierarchy } from './lib/hierarchyShape.js';
export class HierarchyNode {
    resource;
    hierarchyLevel;
    constructor(resource, hierarchyLevel) {
        this.resource = resource;
        this.hierarchyLevel = hierarchyLevel;
    }
    get nextInHierarchy() {
        const nextLevel = this.hierarchyLevel.out(meta.nextInHierarchy);
        if (!isGraphPointer(nextLevel)) {
            return [];
        }
        const path = nextLevel.out(rdf.ns.sh.path);
        if (!isGraphPointer(path)) {
            throw new Error('sh:path must be single node');
        }
        return findNodes(this.resource, path)
            .map(child => new HierarchyNode(child, nextLevel));
    }
}
export function getHierarchy(hierarchy, { properties = [], shapeToQueryOptions } = {}) {
    const constraints = {
        properties: properties.reduce((previousValue, currentValue) => {
            const next = 'termType' in currentValue ? [currentValue, {}] : currentValue;
            return [...previousValue, next];
        }, []),
    };
    const shape = fromHierarchy(hierarchy, constraints);
    const query = constructQuery(shape, shapeToQueryOptions);
    return {
        query,
        shape,
        async execute(client, $rdf) {
            const stream = await client.query.construct(query, { operation: 'postUrlencoded' });
            const dataset = await fromStream($rdf.dataset(), stream);
            const roots = rdf.clownface({ dataset }).node(hierarchy.out(meta.hierarchyRoot));
            return roots.map(root => new HierarchyNode(root, hierarchy));
        },
    };
}
